/**
 * Animation timing tokens shared between the Radix Sheet/Dialog wrappers and
 * any logic whose correctness is coupled to their transition duration.
 *
 * `RADIX_OPEN_ANIMATION_MS` mirrors the `duration-200` utility baked into BOTH
 * the `SheetContent` and `DialogContent` className (see `ui/sheet.tsx` and
 * `ui/dialog.tsx` — both wrap the same Radix Dialog primitive). It lives here,
 * not inline as a bare literal, so the coupling is explicit: deferred-focus
 * logic (`useDeferredAutoFocus`) keys its settle delay off this value, and a
 * design-system change to the open/close duration is a single edit here + the
 * matching `duration-*` class — not a silent drift that re-opens the iOS
 * keyboard race.
 *
 * `ANIMATION_SETTLE_SLACK_MS` is the extra margin added on top of the animation
 * duration before a deferred action (focus) fires, so it lands AFTER the
 * transition has fully settled rather than on its last frame.
 *
 * If the `duration-200` class changes, update `RADIX_OPEN_ANIMATION_MS`.
 */
export const RADIX_OPEN_ANIMATION_MS = 200

export const ANIMATION_SETTLE_SLACK_MS = 50

/**
 * Whether the user prefers reduced motion — the ONE place this media query is
 * asked (frontend/CLAUDE.md: all animations must respect
 * prefers-reduced-motion). Guarded for environments without matchMedia
 * (jsdom in unit tests) so callers never need their own typeof checks.
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}
